/* ============================================================
   soqi — storefront behaviour (vanilla JS, Shopify Ajax API)
   ============================================================ */
(function () {
  "use strict"

  var SOQI = window.SOQI || {}
  var CUR = SOQI.currency || "USD"
  var FREE_SHIP = (SOQI.freeShip != null ? SOQI.freeShip : 75) * 100 // cents
  var R = SOQI.routes || {}
  var R_CART = R.cart || "/cart"
  var R_ADD = R.cartAdd || "/cart/add"
  var KLAVIYO_COMPANY = SOQI.klaviyoCompany || ""
  var KLAVIYO_LIST = SOQI.klaviyoList || ""

  // matches Liquid's money_without_trailing_zeros: cents only when there are any
  function priceText(cents) {
    var exact = (cents || 0) % 100 === 0
    return new Intl.NumberFormat("en-US", {
      style: "currency", currency: CUR,
      minimumFractionDigits: exact ? 0 : 2, maximumFractionDigits: exact ? 0 : 2
    }).format((cents || 0) / 100)
  }
  function $(s, r) { return (r || document).querySelector(s) }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)) }

  /* ── Theme toggle ───────────────────────────────────── */
  function applyTheme(t) {
    document.documentElement.setAttribute("data-theme", t)
    $all("[data-theme-toggle]").forEach(function (b) {
      // the control is a switch: "on" means dark. CSS moves the knob.
      b.setAttribute("aria-checked", t === "dark" ? "true" : "false")
      // older markup kept a glyph and a text label; support it if present
      var g = b.querySelector(".glyph"), l = b.querySelector(".label")
      if (g) g.textContent = t === "dark" ? "☀" : "☾"
      if (l) l.textContent = t === "dark" ? "Light" : "Dark"
    })
  }
  function initTheme() {
    var t = SOQI.defaultTheme || "light"
    try { t = localStorage.getItem("soqi_theme") || t } catch (e) {}
    applyTheme(t)
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-theme-toggle]")
      if (!btn) return
      var cur = document.documentElement.getAttribute("data-theme") === "dark" ? "dark" : "light"
      var next = cur === "dark" ? "light" : "dark"
      try { localStorage.setItem("soqi_theme", next) } catch (e2) {}
      applyTheme(next)
    })
  }

  /* ── Mobile menu ────────────────────────────────────── */
  function initMenu() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-menu-toggle]")
      if (!btn) return
      var menu = $("[data-mobile-menu]")
      if (menu) {
        var open = menu.classList.toggle("open")
        // the bars are drawn, so the state rides on aria-expanded, which the
        // CSS reads to cross them; overwriting textContent would delete them
        btn.setAttribute("aria-expanded", open ? "true" : "false")
        btn.setAttribute("aria-label", open ? "Close menu" : "Menu")
      }
    })
  }

  /* ── Scroll reveal ──────────────────────────────────── */
  function initReveal() {
    var els = $all(".reveal")
    function show(el) { el.classList.add("in") }
    if (!("IntersectionObserver" in window)) { els.forEach(show); return }

    // anything already on screen reveals immediately, so the first paint is never blank
    var vh = window.innerHeight || document.documentElement.clientHeight
    els.forEach(function (el) { if (el.getBoundingClientRect().top < vh) show(el) })

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { show(en.target); io.unobserve(en.target) } })
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" })
    els.forEach(function (el) { if (!el.classList.contains("in")) io.observe(el) })

    // safety net: never leave content hidden if the observer never fires
    setTimeout(function () { els.forEach(show) }, 4000)
  }

  /* ── Cart drawer ────────────────────────────────────── */
  /* The cart add-on shows only when the cart holds something the automatic
     discount applies to and does not already hold the offered product. The
     qualifying ids come from Liquid: /cart.js reports lines, not collections. */
  function syncCartUpsell(cart) {
    var el = $("[data-cart-upsell]"); if (!el) return
    var qualifying = (el.getAttribute("data-qualifying") || "").split(",").filter(Boolean)
    var offered = el.getAttribute("data-upsell-product")
    var items = cart.items || []
    var earnsIt = items.some(function (i) { return qualifying.indexOf(String(i.product_id)) > -1 })
    var hasIt = items.some(function (i) { return String(i.product_id) === offered })
    el.hidden = !(items.length && earnsIt && !hasIt)
  }

  function syncCartBowls(cart) {
    var el = $("[data-cart-bowls]"); if (!el) return
    var ceramics = (el.getAttribute("data-ceramics") || "").split(",").filter(Boolean)
    var tea = el.getAttribute("data-tea")
    var items = cart.items || []
    var hasCeramic = items.some(function (i) { return ceramics.indexOf(String(i.product_id)) > -1 })
    el.hidden = !(items.length && !hasCeramic)
    var rowEl = $("[data-bowls-row]", el)
    if (rowEl && !el.hidden) requestAnimationFrame(function () { rowEl.dispatchEvent(new Event("scroll")) })
    var note = $("[data-cart-bowls-note]", el)
    if (note) {
      // The tin only drops while it is still at full price -- a bundle or a
      // subscription may already have cut it.
      var fullPriceTea = items.some(function (i) {
        return String(i.product_id) === tea && !i.selling_plan_allocation && i.final_price >= i.original_price
      })

      // Free shipping is promised only if even the cheapest bowl gets there,
      // and only if the cart is not already past the line. The tin's $15 drop
      // is taken off only when a tin is at full price: checked against live
      // carts, a bundle price or a subscription is not cut again by a bowl.
      var prices = $all("[data-bowl-price]", el).map(function (b) { return Number(b.getAttribute("data-bowl-price")) })
      var cheapest = prices.length ? Math.min.apply(null, prices) : 0
      var drop = fullPriceTea ? Number(note.getAttribute("data-tea-drop") || 0) : 0
      var total = cart.total_price
      var shipsFree = cheapest > 0 && total < FREE_SHIP && (total + cheapest - drop) >= FREE_SHIP

      var to = note.getAttribute("data-tea-to")
      var text = ""
      if (fullPriceTea && shipsFree) text = "Add any bowl — your matcha drops to " + to + " and your order ships free."
      else if (fullPriceTea) text = "Add any bowl and your matcha drops to " + to + "."
      else if (shipsFree) text = "Add any bowl and your order ships free."
      note.textContent = text
      note.hidden = !text
    }
  }

  /* Arrows for the bowls row, for a mouse that cannot swipe. Scrolls by one
     tile and greys out at either end. Delegated, since the drawer re-renders. */
  function initBowlsRail() {
    function update(row) {
      var box = row.closest("[data-cart-bowls]"); if (!box) return
      var prev = $("[data-bowls-scroll='-1']", box), next = $("[data-bowls-scroll='1']", box)
      if (prev) prev.disabled = row.scrollLeft <= 2
      if (next) next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2
    }
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-bowls-scroll]"); if (!btn) return
      var row = $("[data-bowls-row]", btn.closest("[data-cart-bowls]")); if (!row) return
      var tile = $(".cart-bowl", row)
      var step = tile ? tile.getBoundingClientRect().width + 10 : row.clientWidth * 0.8
      row.scrollBy({ left: step * Number(btn.getAttribute("data-bowls-scroll")), behavior: "smooth" })
    })
    document.addEventListener("scroll", function (e) {
      if (e.target && e.target.matches && e.target.matches("[data-bowls-row]")) update(e.target)
    }, true)
    /* The pieces chosen in settings keep their place; everything after them is
       shuffled once per page load. Done here rather than in Liquid because the
       storefront caches rendered HTML, so a server-side shuffle would show every
       visitor the same "random" order. */
    $all("[data-bowls-row]").forEach(function (row) {
      var loose = $all(".cart-bowl:not([data-bowl-pinned])", row)
      for (var i = loose.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1))
        var tmp = loose[i]; loose[i] = loose[j]; loose[j] = tmp
      }
      loose.forEach(function (li) { row.appendChild(li) })
      update(row)
    })
  }

  /* A discounted line should say so. Showing only the reduced figure hides the
     saving entirely -- the customer cannot tell $30 from a $30 product.
     Prices are per unit, matching the figure this line already showed, so the
     saving says "each" when more than one is in the line. */
  function priceLine(it) {
    var now = priceText(it.final_price)
    // A subscription is not a discount allocation: the plan sets the price, so
    // original_price already equals it. The figure it saves against lives on
    // the allocation's compare_at_price instead.
    var was = it.original_price
    var plan = it.selling_plan_allocation
    if (plan && plan.compare_at_price > was) was = plan.compare_at_price

    if (was <= it.final_price) {
      return '<p class="line-price">' + now + "</p>"
    }
    var saved = was - it.final_price
    return '<p class="line-price">' + now +
      '<s class="line-was">' + priceText(was) + "</s>" +
      '<span class="line-save">You save ' + priceText(saved) +
        (it.quantity > 1 ? " each" : "") + "</span></p>"
  }

  /* A subscribed line should say so. Without this the cart shows a subscribed
     tin exactly like a one-time one -- same title, same price line -- and the
     only hint is the saving, which the bowl add-on produces too.

     The cadence is read from the plan's option value ("Deliver every 3 weeks")
     rather than its name: Shopify generates the name with the discount
     appended ("Deliver every 3 weeks, $15.00 off"), which would repeat what
     the price line beneath it already says. The name is kept as a fallback,
     trimmed at the comma, in case a plan is ever saved without options. */
  function planLine(it) {
    var alloc = it.selling_plan_allocation
    var plan = alloc && alloc.selling_plan
    if (!plan) return ""

    var opt = (plan.options || [])[0]
    var cadence = opt && typeof opt === "object" ? opt.value : opt
    if (!cadence) cadence = String(plan.name || "").split(",")[0]
    if (!cadence) return ""

    // --c-moss and --c-ink-soft are both redefined for dark mode, so the
    // inline colours follow the toggle; --g-celadon would not.
    return '<p style="display:flex;align-items:baseline;gap:7px;font-size:12px;color:var(--c-ink-soft);margin:5px 0 0;">' +
      '<span style="font-size:10px;letter-spacing:.1em;text-transform:uppercase;color:var(--c-moss);">Subscription</span>' +
      '<span>' + cadence + "</span></p>"
  }

  var CART_IMAGES = null
  function cartImage(it) {
    if (CART_IMAGES === null) {
      try { CART_IMAGES = JSON.parse(($("[data-cart-images]") || {}).textContent || "{}") } catch (e) { CART_IMAGES = {} }
    }
    return CART_IMAGES[String(it.product_id)] || it.image
  }

  function renderCart(cart) {
    var linesEl = $("[data-cart-lines]"), footEl = $("[data-cart-foot]"), shipEl = $("[data-cart-ship]"), countEls = $all("[data-cart-count]")
    syncCartUpsell(cart)
    syncCartBowls(cart)
    if (countEls.length) countEls.forEach(function (c) {
      c.textContent = cart.item_count || ""
      c.hidden = !cart.item_count
    })
    if (!linesEl) return
    if (!cart.items || cart.items.length === 0) {
      linesEl.innerHTML = '<p style="font-size:14px;color:var(--c-ink-soft);padding:32px 0;">Your cart is empty.</p>'
      var upEl = $("[data-cart-upsell]"); if (upEl) upEl.hidden = true
      if (footEl) footEl.hidden = true
      if (shipEl) shipEl.hidden = true
      return
    }
    if (footEl) footEl.hidden = false
    linesEl.innerHTML = cart.items.map(function (it) {
      var sub = it.variant_title && it.variant_title !== "Default Title" ? '<p style="font-size:12px;color:var(--c-ink-soft);margin:3px 0 0;">' + it.variant_title + "</p>" : ""
      return '<div class="line">' +
        '<div class="line-img">' + (cartImage(it) ? '<img src="' + cartImage(it) + '" alt="">' : "") + "</div>" +
        '<div style="flex:1;min-width:0;">' +
          '<p class="n">' + it.product_title + "</p>" + sub + planLine(it) +
          priceLine(it) +
          '<div style="display:flex;align-items:center;gap:14px;margin-top:10px;">' +
            '<div class="qty" style="height:32px;">' +
              '<button data-line-dec="' + it.key + '" style="width:32px;height:32px;">−</button>' +
              '<span style="width:32px;text-align:center;font-size:13px;line-height:32px;border-left:1px solid var(--c-bone-deep);border-right:1px solid var(--c-bone-deep);">' + it.quantity + "</span>" +
              '<button data-line-inc="' + it.key + '" style="width:32px;height:32px;">+</button>' +
            "</div>" +
            '<button data-line-remove="' + it.key + '" style="background:none;border:none;cursor:pointer;font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:var(--c-ink-soft);padding:0;">Remove</button>' +
          "</div>" +
        "</div>" +
      "</div>"
    }).join("")
    if (footEl) $("[data-cart-subtotal]", footEl).textContent = priceText(cart.items_subtotal_price)
    if (shipEl) {
      var sub = cart.items_subtotal_price
      var remaining = Math.max(0, FREE_SHIP - sub)
      var pct = Math.min(100, sub / FREE_SHIP * 100)
      $("[data-ship-msg]", shipEl).textContent = remaining > 0 ? "You're " + priceText(remaining) + " from complimentary shipping" : "Complimentary shipping unlocked ✓"
      $("[data-ship-fill]", shipEl).style.width = pct + "%"
      shipEl.hidden = false
    }
  }
  function refreshCart(open) {
    return fetch(R_CART + ".js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json() })
      .then(function (cart) { renderCart(cart); if (open) openDrawer(); return cart })
  }
  function openDrawer() { var o = $("[data-cart-overlay]"), d = $("[data-cart-drawer]"); if (o) o.classList.add("open"); if (d) d.classList.add("open") }
  function closeDrawer() { var o = $("[data-cart-overlay]"), d = $("[data-cart-drawer]"); if (o) o.classList.remove("open"); if (d) d.classList.remove("open") }

  /* ── Quick add from a card ──────────────────────────── */
  function initQuickAdd() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-quick-add]")
      if (!btn || btn.disabled) return
      // the card is a link; without this the browser navigates instead
      e.preventDefault()
      var label = $("[data-quick-add-label]", btn) || $(".card-add-name", btn)
      var was = label ? label.textContent : ""
      btn.disabled = true
      if (label) label.textContent = "Adding…"
      fetch(R_ADD + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: (function () {
          var line = { id: btn.getAttribute("data-quick-add"), quantity: 1 }
          // a subscribe row carries the selling plan the one-time rows do not
          var plan = btn.getAttribute("data-quick-plan")
          if (plan) line.selling_plan = plan
          return JSON.stringify({ items: [line] })
        })()
      })
        .then(function (r) { if (!r.ok) throw new Error("add"); return r.json() })
        .then(function () { return refreshCart(true) })
        .catch(function () { if (label) label.textContent = "Try again" })
        .finally(function () {
          btn.disabled = false
          setTimeout(function () { if (label) label.textContent = was }, 900)
        })
    })
  }

  function initCart() {
    refreshCart(false)
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-cart-open]")) { e.preventDefault(); refreshCart(true) }
      else if (e.target.closest("[data-cart-close]") || e.target.matches("[data-cart-overlay]")) { closeDrawer() }
      else if (e.target.closest("[data-cart-checkout]")) { window.location.href = R_CART + "/checkout" }
      var dec = e.target.closest("[data-line-dec]"), inc = e.target.closest("[data-line-inc]"), rem = e.target.closest("[data-line-remove]")
      if (dec || inc || rem) {
        var key = (dec || inc || rem).getAttribute("data-line-dec") || (dec || inc || rem).getAttribute("data-line-inc") || (dec || inc || rem).getAttribute("data-line-remove")
        changeLine(key, rem ? "remove" : (inc ? "inc" : "dec"))
      }
    })
  }
  function changeLine(key, op) {
    fetch(R_CART + ".js").then(function (r) { return r.json() }).then(function (cart) {
      var item = cart.items.filter(function (i) { return i.key === key })[0]
      if (!item) return
      var q = op === "remove" ? 0 : (op === "inc" ? item.quantity + 1 : item.quantity - 1)
      return fetch("/cart/change.js", {
        method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: key, quantity: q })
      }).then(function (r) { return r.json() }).then(function (c) { renderCart(c) })
    })
  }

  /* ── Add to cart (product form) ─────────────────────── */
  function initProductForm() {
    var form = $("[data-product-form]")
    if (!form) return
    /* Buy now sits above Add to cart, and pressing Enter in a field submits with
       the form's first submit button -- which would send someone to checkout
       from the quantity box. Enter should keep meaning "add to cart". */
    form.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" || e.target.tagName !== "INPUT") return
      var add = $("[data-add]", form)
      if (!add || add.disabled) return
      e.preventDefault()
      if (form.requestSubmit) form.requestSubmit(add)
      else add.click()
    })
    form.addEventListener("submit", function (e) {
      e.preventDefault()
      var buyNow = e.submitter && e.submitter.hasAttribute("data-buy-now")
      var btn = e.submitter || $("[data-add]", form)
      if (btn) btn.disabled = true

      // the add-on means a line can carry two items, which FormData cannot
      // express -- the items array needs JSON
      var hidden = $("[data-variant-id]", form)
      var qtyEl = $("[data-qty-input]", form)
      var line = { id: hidden ? hidden.value : null, quantity: parseInt(qtyEl && qtyEl.value || "1", 10) || 1 }
      var plan = $("[data-plan]:checked", form)
      if (plan && plan.value) line.selling_plan = plan.value
      var items = [line]
      var addOn = $("[data-upsell-check]", form)
      if (addOn && addOn.checked) items.push({ id: addOn.value, quantity: 1 })

      fetch(R_ADD + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json() })
        .then(function () {
          if (buyNow) { window.location.href = R_CART + "/checkout"; return }
          return refreshCart(true)
        })
        .catch(function () {})
        .finally(function () { if (btn) btn.disabled = false })
    })
  }

  /* ── Product gallery + variants + qty ───────────────── */
  function initGallery() {
    $all("[data-thumb]").forEach(function (t) {
      t.addEventListener("click", function () {
        var src = t.getAttribute("data-thumb")
        var main = $("[data-main-img]")
        if (main) main.src = src
        $all("[data-thumb]").forEach(function (x) { x.classList.remove("active") })
        t.classList.add("active")
      })
    })
    var qtyInput = $("[data-qty-input]")
    $all("[data-qty-step]").forEach(function (b) {
      b.addEventListener("click", function () {
        if (!qtyInput) return
        var v = parseInt(qtyInput.value || "1", 10)
        v = b.getAttribute("data-qty-step") === "inc" ? v + 1 : Math.max(1, v - 1)
        qtyInput.value = v
        syncPrice()
      })
    })
    // purchase options: the price shown on the button depends on variant x plan
    var prices = null
    var priceTag = $("[data-plan-prices]")
    if (priceTag) { try { prices = JSON.parse(priceTag.textContent) } catch (e) {} }

    function currentPlan() {
      var checked = $("[data-plan]:checked")
      return checked ? checked.value : ""
    }
    function syncPrice() {
      var priceEl = $("[data-add-price]")
      if (!priceEl || !prices) return
      var hidden = $("[data-variant-id]")
      var row = hidden ? prices[hidden.value] : null
      if (!row) return

      var plan = currentPlan()
      var unit = plan && row.plans[plan] != null ? row.plans[plan] : row.base
      var qtyEl = $("[data-qty-input]")
      var qty = Math.max(1, parseInt(qtyEl && qtyEl.value || "1", 10) || 1)

      // the button states the total being added, so the add-on and the
      // quantity both belong in it -- the add-on is always a single tin
      var total = unit * qty
      var addOn = $("[data-upsell-check]")
      if (addOn && addOn.checked) total += parseInt(addOn.getAttribute("data-upsell-cents"), 10) || 0

      priceEl.textContent = priceText(total)
    }
    $all("[data-plan]").forEach(function (r) {
      // the option rows keep their own prices; only the button total moves
      r.addEventListener("change", syncPrice)
    })
    var upsellBox = $("[data-upsell-check]")
    if (upsellBox) upsellBox.addEventListener("change", syncPrice)

    // variant select
    $all("[data-variant]").forEach(function (v) {
      v.addEventListener("click", function () {
        if (v.getAttribute("data-available") === "false") return
        $all("[data-variant]").forEach(function (x) { x.classList.remove("active") })
        v.classList.add("active")
        var id = v.getAttribute("data-variant")
        var hidden = $("[data-variant-id]")
        if (hidden) hidden.value = id
        // the button total is derived, not copied, so one call covers it
        syncPrice()
        // the purchase-option rows show this variant's own prices
        var row = prices ? prices[id] : null
        if (row) {
          $all("[data-plan]").forEach(function (r) {
            var label = r.closest(".buy-opt")
            var out = label && label.querySelector(".buy-opt-price")
            if (!out) return
            var cents = r.value ? row.plans[r.value] : row.base
            if (cents != null) out.childNodes[0].nodeValue = priceText(cents) + " "
          })
        }
      })
    })
  }

  /* ── Lightbox ───────────────────────────────────────── */
  function initLightbox() {
    var lb = $("[data-lightbox]"); if (!lb) return
    var img = $("[data-lightbox-img]", lb)
    document.addEventListener("click", function (e) {
      var main = e.target.closest("[data-main-img]")
      if (main) { img.src = main.src; lb.classList.add("open") }
      else if (e.target.closest("[data-lightbox-close]") || e.target === lb) { lb.classList.remove("open") }
    })
  }

  /* ── Story tabs ─────────────────────────────────────── */
  function initTabs() {
    $all("[data-tab]").forEach(function (tab) {
      tab.addEventListener("click", function () {
        var grp = tab.closest("[data-tabs]"); if (!grp) return
        var idx = tab.getAttribute("data-tab")
        $all("[data-tab]", grp).forEach(function (t) { t.classList.toggle("active", t === tab) })
        $all("[data-panel]", grp).forEach(function (p) { p.classList.toggle("active", p.getAttribute("data-panel") === idx) })
      })
    })
  }

  /* ── Newsletter (Klaviyo) ───────────────────────────── */
  function initNewsletter() {
    if (!KLAVIYO_COMPANY) return
    $all("[data-newsletter]").forEach(function (form) {
    var LABEL = (($("button", form) || {}).textContent || "Subscribe").trim()
    form.addEventListener("submit", function (e) {
      e.preventDefault()
      var input = $("input[type=email]", form), note = $("[data-news-note]", form), btn = $("button", form)
      if (!input || !input.value) return
      if (btn) { btn.disabled = true; btn.textContent = "Joining…" }
      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + KLAVIYO_COMPANY, {
        method: "POST",
        headers: { "Content-Type": "application/json", "revision": "2024-10-15" },
        body: JSON.stringify({ data: { type: "subscription", attributes: { custom_source: "soqi shopify", profile: { data: { type: "profile", attributes: { email: input.value.trim(), subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } } } } } }, relationships: { list: { data: { type: "list", id: KLAVIYO_LIST } } } } })
      }).then(function (r) {
        if (r.ok || r.status === 202) { form.innerHTML = '<p style="font-size:15px;color:#F5F2EC;">Thank you — you\'re on the list.</p>' }
        else if (note) { note.textContent = "Something went wrong — please try again."; if (btn) { btn.disabled = false; btn.textContent = "Subscribe" } }
      }).catch(function () { if (note) note.textContent = "Something went wrong — please try again."; if (btn) { btn.disabled = false; btn.textContent = LABEL } })
    })
    })
  }


  /* ── Announcement rotator ───────────────────────────── */
  function initAnnounce() {
    $all("[data-announce-rotate]").forEach(function (track) {
      var items = $all(".announce-item", track)
      if (items.length < 2) return
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return
      var i = 0
      var every = (parseInt(track.getAttribute("data-announce-rotate"), 10) || 6) * 1000
      setInterval(function () {
        items[i].classList.remove("is-active")
        i = (i + 1) % items.length
        items[i].classList.add("is-active")
      }, every)
    })
  }


  /* ── Hero video controls ────────────────────────────── */
  function initHeroVideo() {
    var hero = $(".hero"); if (!hero) return
    var vid = $("video", hero); if (!vid) return
    var playBtn = $("[data-hero-play]", hero)
    var muteBtn = $("[data-hero-mute]", hero)

    function paint() {
      if (playBtn) {
        playBtn.setAttribute("data-state", vid.paused ? "paused" : "playing")
        playBtn.setAttribute("aria-label", vid.paused ? "Play background video" : "Pause background video")
      }
      if (muteBtn) {
        muteBtn.setAttribute("data-state", vid.muted ? "muted" : "unmuted")
        muteBtn.setAttribute("aria-label", vid.muted ? "Unmute background video" : "Mute background video")
      }
    }

    /* The clip's opening is skipped via a #t= fragment on the source, but the
       native loop restarts at zero — which would drop the viewer back into the
       part we deliberately skipped. So hold the floor here instead. */
    var startAt = parseFloat(vid.getAttribute("data-start") || "0") || 0
    if (startAt > 0) {
      var seekStart = function () {
        try { if (vid.currentTime < startAt - 0.25) vid.currentTime = startAt } catch (e) {}
      }
      vid.addEventListener("loadedmetadata", seekStart)
      vid.addEventListener("timeupdate", seekStart)
      seekStart()
    }

    // Someone who asked the OS for less motion should not be handed an
    // autoplaying full-bleed video.
    var calm = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches
    if (calm) { try { vid.pause() } catch (e) {} }

    /* The markup already carries autoplay/muted/playsinline, which is enough
       for most browsers. iOS can still refuse -- Low Power Mode, or Safari set
       to never autoplay -- and it refuses silently, leaving a still frame. So
       ask once on load, and if that is rejected, ask again the first time the
       page is touched or returns to the foreground, which are the moments the
       refusal is typically lifted.

       userPaused guards it: if someone presses pause, their next tap must not
       start it up again. */
    var userPaused = false
    function attempt() {
      if (calm || userPaused || !vid.paused) return
      // set as properties too: Safari has historically ignored late attributes
      vid.muted = true
      vid.playsInline = true
      var p = vid.play()
      if (p && p.catch) p.catch(function () {})
    }
    function retryOnce() {
      attempt()
      if (!vid.paused) removeRetries()
    }
    function removeRetries() {
      document.removeEventListener("touchstart", retryOnce)
      document.removeEventListener("click", retryOnce)
      document.removeEventListener("visibilitychange", retryOnce)
    }
    attempt()
    if (vid.paused && !calm) {
      document.addEventListener("touchstart", retryOnce, { passive: true })
      document.addEventListener("click", retryOnce)
      document.addEventListener("visibilitychange", retryOnce)
    }

    if (playBtn) playBtn.addEventListener("click", function () {
      if (vid.paused) { userPaused = false; vid.play().catch(function () {}) }
      else { userPaused = true; vid.pause() }
    })
    if (muteBtn) muteBtn.addEventListener("click", function () {
      vid.muted = !vid.muted
      if (!vid.muted && vid.paused) vid.play().catch(function () {})
      paint()
    })
    vid.addEventListener("play", function () { removeRetries(); paint() })
    vid.addEventListener("pause", paint)
    paint()
  }


  /* ── Email popup ────────────────────────────────────────
     <dialog>.showModal() carries the focus trap, Escape handling and inert
     background, so none of that is hand-rolled here. What this adds is when to
     open, whether to open at all, and where the discount code comes from. */
  function initPopup() {
    var dlg = $("[data-popup]"); if (!dlg || !dlg.showModal) return

    var KEY = "soqi_popup"
    var days = parseInt(dlg.getAttribute("data-days"), 10) || 30
    var delay = (parseInt(dlg.getAttribute("data-delay"), 10) || 0) * 1000
    var endpoint = (dlg.getAttribute("data-endpoint") || "").trim()

    function seen() {
      try {
        var raw = localStorage.getItem(KEY); if (!raw) return false
        var rec = JSON.parse(raw)
        // a subscriber is never asked again; a decline is asked again later
        if (rec.state === "subscribed") return true
        return (Date.now() - rec.at) < days * 864e5
      } catch (e) { return false }
    }
    function remember(state) {
      try { localStorage.setItem(KEY, JSON.stringify({ state: state, at: Date.now() })) } catch (e) {}
    }

    if (seen()) return

    var offer = $("[data-popup-offer]", dlg)
    var done = $("[data-popup-success]", dlg)
    var form = $("[data-popup-form]", dlg)
    var err = $("[data-popup-error]", dlg)

    var timer = setTimeout(open, delay)
    function open() {
      clearTimeout(timer)
      if (dlg.open) return
      try { dlg.showModal() } catch (e) { return }
      var input = $("input[type=email]", dlg); if (input) input.focus()
    }
    // closing by any route counts as a decline, including Escape and backdrop
    dlg.addEventListener("close", function () {
      if (dlg.getAttribute("data-state") !== "subscribed") remember("dismissed")
    })
    $all("[data-popup-close]", dlg).forEach(function (b) {
      b.addEventListener("click", function () { dlg.close() })
    })
    dlg.addEventListener("click", function (e) {
      // a click on the dialog itself is the backdrop; the panel stops its own
      if (e.target === dlg) dlg.close()
    })

    function fail(msg) {
      if (!err) return
      err.textContent = msg
      err.hidden = false
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault()
      var input = $("input[type=email]", form)
      var btn = $("button[type=submit]", form)
      var email = (input.value || "").trim()
      if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        fail("Enter a valid email address."); input.focus(); return
      }
      if (err) err.hidden = true
      var label = btn.textContent
      btn.disabled = true; btn.textContent = "One moment…"

      subscribe(email)
        .then(function () { return endpoint ? mintCode(email) : null })
        .then(function (code) { succeed(code) })
        .catch(function () {
          // the subscription is the thing that matters; if only the code call
          // failed, still welcome them and fall back to the email path
          if (dlg.getAttribute("data-subscribed") === "1") { succeed(null); return }
          btn.disabled = false; btn.textContent = label
          fail("Something went wrong — please try again.")
        })
    })

    function subscribe(email) {
      if (!KLAVIYO_COMPANY) return Promise.resolve()
      return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + KLAVIYO_COMPANY, {
        method: "POST",
        headers: { "Content-Type": "application/json", "revision": "2024-10-15" },
        body: JSON.stringify({ data: { type: "subscription", attributes: {
          custom_source: "soqi popup",
          profile: { data: { type: "profile", attributes: { email: email,
            subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } } } } } },
          relationships: { list: { data: { type: "list", id: KLAVIYO_LIST } } } } })
      }).then(function (r) {
        if (!r.ok && r.status !== 202) throw new Error("subscribe")
        dlg.setAttribute("data-subscribed", "1")
      })
    }

    function mintCode(email, retry) {
      return fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email })
      }).then(function (r) {
        if (!r.ok) throw new Error("mint")
        return r.json()
      }).then(function (d) { return (d && d.code) || null })
        .catch(function (e) {
          // the call is idempotent, so one retry is safe and covers a cold
          // start or a blip; anything past that falls back to the email path
          if (retry) throw e
          return mintCode(email, true)
        })
    }

    function succeed(code) {
      dlg.setAttribute("data-state", "subscribed")
      remember("subscribed")
      if (offer) offer.hidden = true
      if (done) done.hidden = false
      var codeWrap = $("[data-popup-code-wrap]", dlg)
      var mailWrap = $("[data-popup-email-wrap]", dlg)
      if (code && codeWrap) {
        $("[data-popup-code]", dlg).textContent = code
        codeWrap.hidden = false
        var copy = $("[data-popup-copy]", dlg)
        if (copy) copy.addEventListener("click", function () {
          if (navigator.clipboard) navigator.clipboard.writeText(code).then(function () {
            copy.textContent = "Copied"
            setTimeout(function () { copy.textContent = "Copy" }, 2000)
          })
        })
      } else if (mailWrap) {
        mailWrap.hidden = false
      }
      var cont = $(".popup-continue", dlg); if (cont) cont.focus()
    }
  }

  /* ── Damage claim ───────────────────────────────────── */
  function initClaim() {
    var root = $("[data-claim]"); if (!root) return
    var endpoint = (root.getAttribute("data-endpoint") || "").trim()
    var lookup = $("[data-claim-lookup]", root)
    var detail = $("[data-claim-detail]", root)
    var done = $("[data-claim-done]", root)
    var photos = []      // data URLs, read once so a re-submit costs nothing
    var token = null

    function fail(form, msg) {
      var el = $("[data-claim-error]", form)
      if (!el) return
      el.textContent = msg
      el.hidden = false
    }
    function clearError(form) {
      var el = $("[data-claim-error]", form); if (el) el.hidden = true
    }
    function show(step) {
      ;[lookup, detail, done].forEach(function (s) { if (s) s.hidden = s !== step })
      step.scrollIntoView({ block: "nearest", behavior: "smooth" })
    }
    function busy(form, on, label) {
      var b = $("button[type=submit]", form)
      if (!b) return
      if (on) { b.dataset.label = b.textContent; b.textContent = label; b.disabled = true }
      else { b.textContent = b.dataset.label || b.textContent; b.disabled = false }
    }

    /* Step one -------------------------------------------------------- */
    lookup.addEventListener("submit", function (e) {
      e.preventDefault()
      clearError(lookup)
      var order = lookup.elements.order.value.trim()
      var email = lookup.elements.email.value.trim()
      if (!order || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        return fail(lookup, "Enter your order number and the email you ordered with.")
      }
      busy(lookup, true, "Looking…")
      fetch(endpoint + "/lookup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ order: order, email: email })
      })
        .then(function (r) { return r.json() })
        .then(function (d) {
          if (d.error) return fail(lookup, d.error)
          if (!d.eligible) return fail(lookup, d.message)
          token = d.order.token
          renderItems(d)
          show(detail)
        })
        .catch(function () { fail(lookup, "We could not reach the service. Please try again.") })
        .finally(function () { busy(lookup, false) })
    })

    function renderItems(d) {
      $("[data-claim-found]", detail).textContent =
        "Order " + d.order.name + " — choose the item the claim is about."
      var box = $("[data-claim-items]", detail)
      box.innerHTML = d.items.map(function (it, i) {
        var name = it.title + (it.variantTitle ? " · " + it.variantTitle : "")
        if (!it.claimable) {
          return '<div class="claim-item claim-item--out"><span>' + name + '</span><em>' + it.reason + "</em></div>"
        }
        return '<label class="claim-item"><input type="checkbox" name="line" value="' + it.id +
          '"><span>' + name + (it.quantity > 1 ? " × " + it.quantity : "") + "</span></label>"
      }).join("")
      if (!$("input[name=line]", box)) {
        box.innerHTML += '<p class="claim-hint">Nothing on this order can be claimed against here. Please write to us.</p>'
      }
    }

    /* Photographs ----------------------------------------------------- */
    var input = $("[data-claim-photos]", detail)
    var thumbs = $("[data-claim-thumbs]", detail)
    if (input) input.addEventListener("change", function () {
      photos = []
      thumbs.innerHTML = ""
      var files = Array.prototype.slice.call(input.files, 0, 4)
      files.forEach(function (f) {
        var reader = new FileReader()
        reader.onload = function () {
          photos.push(reader.result)
          var img = document.createElement("img")
          img.src = reader.result
          img.alt = ""
          thumbs.appendChild(img)
        }
        reader.readAsDataURL(f)
      })
    })

    /* Step two -------------------------------------------------------- */
    detail.addEventListener("submit", function (e) {
      e.preventDefault()
      clearError(detail)
      var lines = $all("input[name=line]:checked", detail).map(function (i) { return i.value })
      var reason = $("input[name=reason]:checked", detail)
      var note = detail.elements.note.value.trim()
      if (!lines.length) return fail(detail, "Choose which item the claim is about.")
      if (!reason) return fail(detail, "Tell us what went wrong.")
      if (note.length < 10) return fail(detail, "A sentence or two about what happened, please.")
      if (!photos.length) return fail(detail, "Our policy asks for a photograph, so please attach at least one.")

      busy(detail, true, "Sending…")
      fetch(endpoint + "/claim", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: token, lineIds: lines, reason: reason.value, note: note, photos: photos })
      })
        .then(function (r) { return r.json() })
        .then(function (d) {
          if (d.error) return fail(detail, d.error)
          if (!d.ok) return fail(detail, d.message || "That claim could not be filed.")
          $("[data-claim-reference]", done).textContent = d.reference
          show(done)
        })
        .catch(function () { fail(detail, "We could not reach the service. Please try again.") })
        .finally(function () { busy(detail, false) })
    })

    var back = $("[data-claim-back]", detail)
    if (back) back.addEventListener("click", function () {
      photos = []; token = null
      if (input) input.value = ""
      thumbs.innerHTML = ""
      clearError(detail)
      show(lookup)
    })
  }

  /* ── Sticky buy bar ─────────────────────────────────────
     Shown only once the real add-to-cart has scrolled off, and it drives that
     same button so variant, quantity and selling plan are whatever the form
     currently says — no second source of truth. */
  function initStickyBuy() {
    var bar = $("[data-pdp-sticky]"); if (!bar) return
    var actions = $(".pdp-actions")
    var realAdd = $("[data-add]")
    if (!actions || !realAdd) { bar.remove(); return }
    var priceEl = $("[data-sticky-price]", bar)

    /* Visible from first load. On a phone the real buttons sit below the fold
       (80-400px, depending on the device), so the bar is the only way to buy
       without scrolling. It steps aside only while the real buttons are
       actually on screen, so the two never show at once, and returns once
       they have been scrolled past.

       A position check rather than IntersectionObserver: IO only fires when the
       intersection state changes, and a fast scroll can carry the buttons from
       below the fold to above it without them ever registering as visible. */
    var ticking = false
    function sync() {
      ticking = false
      var r = actions.getBoundingClientRect()
      var onScreen = r.bottom > 0 && r.top < window.innerHeight - bar.offsetHeight
      var show = !onScreen
      if (show === bar.hasAttribute("data-shown")) return
      if (show) { bar.setAttribute("data-shown", ""); bar.setAttribute("aria-hidden", "false") }
      else { bar.removeAttribute("data-shown"); bar.setAttribute("aria-hidden", "true") }
    }
    function onScroll() {
      if (ticking) return
      ticking = true
      requestAnimationFrame(sync)
    }
    window.addEventListener("scroll", onScroll, { passive: true })
    window.addEventListener("resize", onScroll)
    sync()

    // Mirror the live price the form already computes.
    var livePrice = $("[data-add-price]")
    if (livePrice && priceEl && "MutationObserver" in window) {
      priceEl.textContent = livePrice.textContent
      new MutationObserver(function () { priceEl.textContent = livePrice.textContent })
        .observe(livePrice, { childList: true, characterData: true, subtree: true })
    }

    // Drive the real button, so variant, quantity, add-on and selling plan all
    // come from the form rather than a second copy of that state.
    $all("[data-sticky-target]", bar).forEach(function (b) {
      b.addEventListener("click", function () {
        var target = b.getAttribute("data-sticky-target") === "buy-now" ? $("[data-buy-now]") : realAdd
        if (!target) target = realAdd
        if (target.disabled) { actions.scrollIntoView({ behavior: "smooth", block: "center" }); return }
        target.click()
      })
    })
  }

  function init() {
    initTheme(); initMenu(); initReveal(); initAnnounce(); initHeroVideo(); initPopup(); initCart(); initQuickAdd(); initBowlsRail(); initClaim(); initProductForm(); initStickyBuy(); initGallery(); initLightbox(); initTabs(); initNewsletter()
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init)
  else init()
})();
